import { Middleware } from "redux";
import { RootState } from "../../../state";
import { serverRequest } from "../../../actions/app/api";
import { APP_URL, GET } from "../../../../_shared/constants";
import { GET_USER_PAST_PROJECT } from "../../../actions";

export const getUserPastProjects: Middleware<unknown, RootState> =
  ({ dispatch }) =>
  (next) =>
  (action) => {
    next(action);
    if (action.type === GET_USER_PAST_PROJECT.START) {
      const { id, suffix, payload, onFinish, ...rest } = action.meta;
      dispatch(
        serverRequest({
          method: GET,
          url: `${APP_URL.user.get}/${id}/${suffix}`,
          onFinish,
          payload,
          onSuccess: GET_USER_PAST_PROJECT.SUCCESS,
          ...rest,
        })
      );
    }
  };
